// NOTE: this is old style of exposing JS into the global context
// To properly use the <script type="module"> approach we will have to do work on webpack CI/CD pipeline and change this small code block to an export instead
window.eviivo = window.eviivo ? window.eviivo : {};
window.eviivo.auth = window.eviivo.auth ? window.eviivo.auth : {};
window.eviivo.auth.loginActivationTimerHandle = window.eviivo.auth.loginActivationTimerHandle ? window.eviivo.auth.loginActivationTimerHandle : {};

window.eviivo.auth.loginActivationTimerHandle = function () {
    const triggerTimer = function (customOptions) {

        // NOTE(s):
        // We don't use the turnstile javascript callback (the one from here: https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/#configurations)
        // This is because we already use the form server side validation of the turnstile token on submit (POST actions).
        // We instead use this timer to just re-enable the action target button when:
        // 1. there is a token present
        // OR
        // 2. a specific time interval has passed (in our case 5 seconds)

        // the timer interval
        // this is set to 75ms for now
        const timerInterval = 75;

        // max number of timer retries before automatically re-enabeling the button
        // this is set to retriesLimit * timerInterval (about 7.5 seconds max with this configuration)
        const retriesLimit = 100;

        let retries = 0;

        function activateButtonOnTimer() {
            // check 1 - check if the turnstile token exists
            let turnstileTokenExists = customOptions.cloudflareTurnstileIsInUse ? false : true;
            if (!turnstileTokenExists) {
                const crfToken = document.getElementsByName("cf-turnstile-response");
                if (crfToken != null && crfToken.length > 0 && crfToken[0].value.length > 0) {
                    turnstileTokenExists = true;
                }
            }

            // check 2 - check if the fingerprint ajax response was done
            let ajaxFingerprintAjaxComplete = customOptions.ajaxFingerprintCallIsInUse ? false : true;
            if (!ajaxFingerprintAjaxComplete) {
                const forms = document.getElementsByClassName("s-main-form");
                if (forms != null && forms.length > 0) {
                    const ajaxCallFlag = forms[0].getAttribute("data-random-ajax-exists")
                    ajaxFingerprintAjaxComplete = ajaxCallFlag != null && ajaxCallFlag.length > 0;
                }
            }

            let reEnableButton = turnstileTokenExists && ajaxFingerprintAjaxComplete;

            if (!reEnableButton) {
                // if we can't yet re-enable the button and the timer retries is still under the max limit we requeue a check again
                if (retries < retriesLimit) {
                    retries++;
                    setTimeout(activateButtonOnTimer, timerInterval);
                    return;
                }

                // if the timer max retries have passed we just re-enable the button anyway
                reEnableButton = true;
            }

            if (reEnableButton) {
                reEnableTargetButton();
            }
        }

        // timer for checking if we should re-enable button
        setTimeout(activateButtonOnTimer, timerInterval);
    };

    function reEnableTargetButton() {
        const targetButtons = document.getElementsByClassName("s-target-button");
        if (targetButtons.length > 0) {
            targetButtons[0].removeAttribute("disabled");
        }
    }

    const resolved = function (token) {
        var turnstileElements = document.getElementsByClassName("s-turnstile-wrapper");
        if (turnstileElements != null && turnstileElements.length > 0 && token.length > 0) {
            document.getElementById("hdnCloudFlareTurnstileToken").value = token;
            turnstileElements[0].classList.remove("alert-border");
            reEnableTargetButton();
        }
    };

    return {
        triggerTimer,
        resolved
    };
}();
